import React from 'react';
import PropTypes from 'prop-types';
import apiFetch from 'modules/api-fetch';
import Toast from 'modules/toast';

import { Formik, Form } from 'formik';

const MessagesEventPrefs = (props) => {
  const { clientData } = props;

  const formSubmit = async (values) => {
    const clientObject = Object.assign({}, props.clientData.data[0]);
    // TODO: improve this to actually loop through an array of keys?
    const eventPrefsValues = {
      foodLog: values.foodLog,
      workout: values.workout,
      task: values.task,
      trainerTask: values.trainerTask,
      progressPhoto: values.progressPhoto,
      bodyStat: values.bodyStat,
      formCheckEntry: values.formCheckEntry,
    };
    // console.devLog.info('Event prefs values:', eventPrefsValues);
    clientObject.messageEventDisplayPrefs = JSON.stringify(eventPrefsValues);
    clientObject.chatMedium = parseInt(values.chatMedium, 10);
    // console.devLog.info('Form submit values:', values);
    // console.devLog.info('Submit formik props:', formikProps);
    // console.devLog.info('Lets see config going out yo', clientObject);
    const config = {
      url: 'Trainer/UpdateClient',
      method: 'POST',
      body: clientObject,
    };
    try {
      await apiFetch(config);
      Toast.success('Profile updated');
      clientData.refreshData(false);
    } catch (e) {
      // console.devLog.info('Messages error:', e);
    }
  };

  const setInitialValues = () => {
    // console.devLog.info('Props client data:', props.clientData.data[0]);
    if (props.clientData.data[0].messageEventDisplayPrefs) {
      const initialValues = {};
      initialValues.chatMedium = props.clientData.data[0].chatMedium;
      initialValues.phoneNumber = props.clientData.data[0].phoneNumber;
      return initialValues;
    }
    return {
      chatMedium: 1,
      phoneNumber: props.clientData.data[0].phoneNumber,
    };
  };
  // console.devLog.info('ALL PROPS:', props.clientData.data[0]);
  if (props.clientData.data.length <= 0) {
    return null;
  }

  return (
    <Formik
      initialValues={setInitialValues()}
      onSubmit={formSubmit}
      render={({ values, handleChange, handleSubmit }) => (
        <div className="ml-2 mt-1">
          {/* Submits form on change: https://github.com/jaredpalmer/formik/issues/1218 */}
          <select
            id="chatMedium"
            className="form-control"
            title="Set message destination"
            value={values.chatMedium}
            onChange={(e) => {
              handleChange(e);
              setTimeout(() => {
                handleSubmit();
              });
            }}
          >
            {/* TODO: Swap these to a function that outputs the options based on the list object below */}
            <option value={1} key={1}>
              Push
            </option>
            <option disabled={values.phoneNumber === null} value={2} key={2}>
              SMS
            </option>
          </select>
        </div>
      )}
    />
  );
};
MessagesEventPrefs.propTypes = {
  clientData: PropTypes.object.isRequired,
};

export default MessagesEventPrefs;
